import { Table, Modal, message, Button, Tag, Space } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import service from "../../../../@services";
import AuthComponent from "../../../../components/AuthComponent";
export default ({
  dataSource,
  loading,
  editArea,
  handleTableChange
}) => {
  const deleteArea = async (id) => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '删除可售模板后，已绑定模板的商品可售区域将回到西南四省，请确认是否删除？',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        await service.area.deleteArea(id)
        message.success('操作成功');
        handleTableChange()
      }
    });
  };
  const columns = [
    { title: '模板ID', dataIndex: 'id', key: 'id' },
    { title: '模板名称', dataIndex: 'templateName', key: 'templateName' },
    {
      title: '可售地区数', dataIndex: 'areaCount', key: 'areaCount'
    },
    { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
    {
      title: '操作',
      width: '150px',
      dataIndex: '',
      key: 'x',
      render: (text, record, index) => (
        <Space>
          <AuthComponent authKey="/brand/update">
            <Button onClick={() => editArea(record)} type="link">编辑
            </Button>
          </AuthComponent>
          <AuthComponent authKey="/brand/delete/{brandId}">
            <Button onClick={() => deleteArea(record.id)} type="link">删除</Button>
          </AuthComponent>
        </Space>
      ),
    },
  ];
  const { list, pageIndex, total, pageSize } = useMemo(() => {
    return {
      list: dataSource.result || [],
      pageIndex: dataSource.pageIndex || 1,
      total: dataSource.recordCount || 0,
      pageSize: dataSource.pageSize || 10
    }
  }, [dataSource])
  return (
    <Table
      rowKey={record => record.code}
      dataSource={list}
      loading={loading}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        position: ['bottomLeft'],
        current: pageIndex,
        pageSize: pageSize,
        total: total
      }}
      columns={columns}
      onChange={(pagination) => handleTableChange({
        pageIndex: pagination.current,
        pageSize: pagination.pageSize
      })}
    />
  )
}